import { t } from 'i18next';
import { useTranslation } from 'react-i18next';

import { InfoCard } from 'core/components';
import { DATE_MONTH_YEAR_LONG_FORMAT } from 'core/constants';
import { formatDate, getDateRangeValue } from 'core/utils';
import { IProjectDetails } from 'projects/types';

interface IProps {
  project: IProjectDetails;
}

export const Duration = ({ project }: IProps) => {
  const { t } = useTranslation();

  return <InfoCard title={t('titleDuration')} items={items(project)} />;
};

const items = (project: IProjectDetails) => [
  {
    label: t('labelCloseDate'),
    value: formatDate(project.closeDate, false, DATE_MONTH_YEAR_LONG_FORMAT),
  },
  {
    label: t('labelValid'),
    value: getDateRangeValue(project.validSince, project.validUntil),
  },
];
